import { Pipe, PipeTransform } from '@angular/core';

import { DeviceType } from '../models/device-type';

@Pipe({
    name: 'sonaDeviceTypeIcon',
    standalone: true
})
export class SonaDeviceTypeIconPipe implements PipeTransform {
    transform(deviceType: DeviceType): string;
    transform(deviceType: string): string | null;
    transform(deviceType: null | undefined): null;
    transform(
        deviceType: DeviceType | string | null | undefined,
    ): string | null;
    transform(
        deviceType: DeviceType | string | null | undefined
    ): string | null {
        switch (deviceType) {
            case 'desktop':
                return 'desktop';
            case 'mobile':
                return 'device-mobile-camera';
        }

        return null;
    }
}
